import React from 'react';

import authActions from './auth/actions';
import { authStore, IAuthStore } from './auth/store';
import avatarActions from './avatar/actions';
import { avatarStore, IAvatarStore } from './avatar/store';
import errorsActions from './errors/actions';
import { errorsStore, IErrorsStore } from './errors/store';
import headerActions from './header/actions';
import { headerStore, IHeaderStore } from './header/store';
import loaderActions from './loader/actions';
import { ILoaderStore, loaderStore } from './loader/store';
import seasonsActions from './seasons/actions';
import { ISeasonsStore, seasonsStore } from './seasons/store';
import userActions from './user/actions';
import { IUserStore, userStore } from './user/store';

import adminEventRoundsActions from './admin/eventRounds/actions';
import { adminEventRoundsStore, IAdminEventRoundsStore } from './admin/eventRounds/store';
import adminEventsActions from './admin/events/actions';
import { adminEventsStore, IAdminEventsStore } from './admin/events/store';

import adminRoundFormatsActions from './admin/roundFormats/actions';
import { adminRoundFormatsStore, IAdminRoundFormatsStore } from './admin/roundFormats/store';

import adminEventFormatsActions from './admin/eventFormats/actions';
import { adminEventFormatsStore, IAdminEventFormatsStore } from './admin/eventFormats/store';

import roundPaymentsActions from './admin/roundPayments/actions';
import { IRoundPaymentsStore, roundPaymentsStore } from './admin/roundPayments/store';

import adminRoundAwardsActions from './admin/roundAwards/actions';
import { adminRoundAwardsStore } from './admin/roundAwards/store';

import adminEventAwardsActions from './admin/eventAwards/actions';
import { adminEventAwardsStore, IAdminEventAwardsStore } from './admin/eventAwards/store';

import adminRoundFormatAwardsActions from './admin/roundFormatAwards/actions';
import {
  adminRoundFormatAwardsStore,
  IAdminRoundFormatAwardsStore
} from './admin/roundFormatAwards/store';

import adminEventFormatAwardsActions from './admin/eventFormatAwards/actions';
import {
  adminEventFormatAwardsStore,
  IAdminEventFormatAwardsStore
} from './admin/eventFormatAwards/store';

import adminRoundResultsActions from './admin/roundResults/actions';
import { adminRoundResultsStore, IAdminRoundResultsStore } from './admin/roundResults/store';

import adminEventResultsActions from './admin/eventResults/actions';
import { adminEventResultsStore, IAdminEventResultsStore } from './admin/eventResults/store';

import adminEventsEnrollmentsActions from './admin/eventEnrollments/actions';
import {
  adminEventEnrollmentsStore,
  IAdminEventEnrollmentsStore
} from './admin/eventEnrollments/store';

import adminFeesActions from './admin/fees/actions';

import adminClubActions from './admin/clubs/actions';
import { adminClubsStore, IAdminClubsStore } from './admin/clubs/store';

import playerEditorModalActions from './admin/playerEditorModal/actions';
import { playerEditorModalStore, IPlayerEditorModalStore } from './admin/playerEditorModal/store';

import adminCoursesActions from './admin/courses/actions';
import { adminCoursesStore, ICourse } from './admin/courses/store';

import adminGroupsActions from './admin/groups/actions';

import adminInvitationsActions from './admin/invitations/actions';
import { adminInvitationsStore, IAdminInvitationsStore } from './admin/invitations/store';

import adminMembershipsActions from './admin/memberships/actions';

import clubsActions from './player/clubs/actions';
import { clubsStore, IClubsStore } from './player/clubs/store';
import eventsActions from './player/events/actions';
import {
  eventRegistrationStore,
  eventRoundsStore,
  eventStore,
  IEventRegistration,
  IEventRoundsStore,
  IEventsStore
} from './player/events/store';

import gamesActions from './player/games/actions';
import { gamesStore, IGamesStore } from './player/games/store';

import scoresActions from './player/scores/actions';
import { IScoresStore, scoresStore } from './player/scores/store';

import { IRoundScoresStore, roundScoresStore } from './admin/roundScores//store';
import roundScoresActions from './admin/roundScores/actions';

import invitationActions from './player/invitation/actions';
import { IInvitationStore, invitationStore } from './player/invitation/store';

import membershipsActions from './player/memberships/actions';
import { IMembershipsStore, membershipsStore } from './player/memberships/store';

import notificationsActions from './notification/actions';
import { INotificationsStore, notificationsStore } from './notification/store';

import { adminMembershipsStore, IAdminMembershipsStore } from './admin/memberships/store';

import { adminGroupsStore, IAdminGroupsStore } from './admin/groups/store';

import roundTeesActions from './roundTees/actions';
import { roundTeesStore, IRoundTeesStore } from './roundTees/store';

import adminClubCreditCardActions from '../store/adminClubCreditCard/actions';
import { adminClubCardStore, IAdminClubCardStore } from './adminClubCreditCard/store';

import adminPlayerEnrollmentsActions from '../store/admin/playerEnrollments/actions';
import {
  adminPlayerEnrollmentsStore,
  IAdminPlayerEnrollmentsStore
} from './admin/playerEnrollments/store';

import standingActions from './player/standings/actions';
import { IStandingsStore, standingsStore } from './player/standings/store';

import pagesActions from './pages/actions';
import { IPagesStore, pagesStore } from './pages/store';

import adminSeasonAwardsActions from './admin/seasonAwards/actions';
import { adminSeasonAwardsStore, IAdminSeasonAwardsStore } from './admin/seasonAwards/store';

import seasonAwardsActions from './player/seasonAwards/actions';
import { ISeasonAwardsStore, seasonAwardsStore } from './player/seasonAwards/store';

import playerProfileActions from './player/profile/actions';
import { IPlayerProfileStore, playerProfileStore } from './player/profile/store';

import roundResultsActions from './player/roundResults/actions';
import { IRoundResultsStore, roundResultsStore } from './player/roundResults/store';

import adminHoleResultsActions from './admin/holeResults/actions';
import { adminHoleResultsStore, IAdminHoleResultsStore } from './admin/holeResults/store';

import holeResultsActions from './player/holeResults/actions';
import { holeResultsStore, IHoleResultsStore } from './player/holeResults/store';

import teamHoleResultsActions from './player/teamHoleResults/actions';

import adminEventTeamsActions from './admin/eventTeams/actions';
import { adminEventTeamsStore, IAdminEventTeamsStore } from './admin/eventTeams/store';

import adminTeamGamesActions from './admin/teamGames/actions';
import { adminTeamGamesStore, IAdminTeamGamesStore } from './admin/teamGames/store';

import adminTeamResultsActions from './admin/teamResults/actions';
import { adminTeamResultsStore, IAdminTeamResultsStore } from './admin/teamResults/store';

import clubInvitationsActions from './clubInvitations/actions';
import { clubInvitationsStore, IClubInvitationsStore } from './clubInvitations/store';

import adminTeamHoleResultsActions from './admin/teamHoleResults/actions';
import {
  adminTeamHoleResultsStore,
  IAdminTeamHoleResultsStore
} from './admin/teamHoleResults/store';

import { TActionsWithoutState } from './Interfaces/TActionsWithoutState';

export interface IActionGroup {
  [key: string]: any;
}

export interface IActions {
  [key: string]: IActionGroup;
}

export interface IStoreActions {
  [key: string]: IActionGroup;
  adminEvents: TActionsWithoutState<typeof adminEventsActions>;
  adminGroups: TActionsWithoutState<typeof adminGroupsActions>;
  adminMemberships: TActionsWithoutState<typeof adminMembershipsActions>;
  adminRoundFormatAwards: TActionsWithoutState<typeof adminRoundFormatAwardsActions>;
  clubInvitations: TActionsWithoutState<typeof clubInvitationsActions>;
  events: TActionsWithoutState<typeof eventsActions>;
  games: TActionsWithoutState<typeof gamesActions>;
  invitation: TActionsWithoutState<typeof invitationActions>;
  notifications: TActionsWithoutState<typeof notificationsActions>;
  seasons: TActionsWithoutState<typeof seasonsActions>;
  roundTees: TActionsWithoutState<typeof roundTeesActions>;
}
export interface IStore {
  actions: IStoreActions;
  adminClubCreditCard: IAdminClubCardStore;
  adminGroups: IAdminGroupsStore;
  adminMemberships: IAdminMembershipsStore;
  adminClubs: IAdminClubsStore;
  adminCourses: ICourse[];
  adminEventAwards: IAdminEventAwardsStore;
  adminEventEnrollments: IAdminEventEnrollmentsStore;
  adminEventFormatAwards: IAdminEventFormatAwardsStore;
  adminEventFormats: IAdminEventFormatsStore;
  adminEventResults: IAdminEventResultsStore;
  adminEventRounds: IAdminEventRoundsStore;
  adminEvents: IAdminEventsStore;
  adminEventTeams: IAdminEventTeamsStore;
  adminHoleResults: IAdminHoleResultsStore;
  adminInvitations: IAdminInvitationsStore;
  adminPlayerEnrollments: IAdminPlayerEnrollmentsStore;
  adminRoundAwards: IAdminEventAwardsStore;
  adminRoundFormatAwards: IAdminRoundFormatAwardsStore;
  adminRoundFormats: IAdminRoundFormatsStore;
  adminRoundPayments: IRoundPaymentsStore;
  adminRoundResults: IAdminRoundResultsStore;
  adminSeasonAwards: IAdminSeasonAwardsStore;
  adminTeamGames: IAdminTeamGamesStore;
  adminTeamHoleResults: IAdminTeamHoleResultsStore;
  adminTeamResults: IAdminTeamResultsStore;
  auth: IAuthStore;
  avatar: IAvatarStore;
  clubInvitations: IClubInvitationsStore;
  clubs: IClubsStore;
  errors: IErrorsStore;
  eventRegistration: IEventRegistration;
  eventRounds: IEventRoundsStore;
  events: IEventsStore;
  roundTees: IRoundTeesStore;
  games: IGamesStore;
  header: IHeaderStore;
  holeResults: IHoleResultsStore;
  invitation: IInvitationStore;
  loader: ILoaderStore;
  memberships: IMembershipsStore;
  notifications: INotificationsStore;
  pages: IPagesStore;
  playerEditorModal: IPlayerEditorModalStore;
  profile: IPlayerProfileStore;
  roundResults: IRoundResultsStore;
  roundScores: IRoundScoresStore;
  scores: IScoresStore;
  seasonAwards: ISeasonAwardsStore;
  seasons: ISeasonsStore;
  standings: IStandingsStore;
  teamHoleResults: IAdminTeamHoleResultsStore;
  user: IUserStore;
}

const store: IStore = {
  actions: {
    adminClubCreditCard: adminClubCreditCardActions,
    adminClubs: adminClubActions,
    adminCourses: adminCoursesActions,
    adminEventAwards: adminEventAwardsActions,
    adminEventEnrollments: adminEventsEnrollmentsActions,
    adminEventFormatAwards: adminEventFormatAwardsActions,
    adminEventFormats: adminEventFormatsActions,
    adminEventResults: adminEventResultsActions,
    adminEventRounds: adminEventRoundsActions,
    adminEventTeams: adminEventTeamsActions,
    adminEvents: (adminEventsActions as never) as TActionsWithoutState<typeof adminEventsActions>,
    adminFees: adminFeesActions,
    adminGroups: (adminGroupsActions as never) as TActionsWithoutState<typeof adminGroupsActions>,
    adminHoleResults: adminHoleResultsActions,
    adminInvitations: adminInvitationsActions,
    adminMemberships: (adminMembershipsActions as never) as TActionsWithoutState<
      typeof adminMembershipsActions
    >,
    adminPlayerEnrollments: adminPlayerEnrollmentsActions,
    adminRoundAwards: adminRoundAwardsActions,
    adminRoundFormatAwards: (adminRoundFormatAwardsActions as never) as TActionsWithoutState<
      typeof adminRoundFormatAwardsActions
    >,
    adminRoundFormats: adminRoundFormatsActions,
    adminRoundPayments: roundPaymentsActions,
    adminRoundResults: adminRoundResultsActions,
    adminSeasonAwards: adminSeasonAwardsActions,
    adminTeamGames: adminTeamGamesActions,
    adminTeamHoleResults: adminTeamHoleResultsActions,
    adminTeamResults: adminTeamResultsActions,
    auth: authActions,
    avatar: avatarActions,
    clubInvitations: (clubInvitationsActions as never) as TActionsWithoutState<
      typeof clubInvitationsActions
    >,
    clubs: clubsActions,
    errors: errorsActions,
    events: (eventsActions as never) as TActionsWithoutState<typeof eventsActions>,
    games: (gamesActions as never) as TActionsWithoutState<typeof gamesActions>,
    header: headerActions,
    holeResults: holeResultsActions,
    invitation: (invitationActions as never) as TActionsWithoutState<typeof invitationActions>,
    loader: loaderActions,
    memberships: membershipsActions,
    notifications: (notificationsActions as never) as TActionsWithoutState<
      typeof notificationsActions
    >,
    pages: pagesActions,
    playerEditorModal: playerEditorModalActions,
    profile: playerProfileActions,
    roundResults: roundResultsActions,
    roundScores: roundScoresActions,
    roundTees: (roundTeesActions as never) as TActionsWithoutState<typeof roundTeesActions>,
    scores: scoresActions,
    seasonAwards: seasonAwardsActions,
    seasons: (seasonsActions as never) as TActionsWithoutState<typeof seasonsActions>,
    standings: standingActions,
    teamHoleResults: teamHoleResultsActions,
    user: userActions
  },
  adminClubCreditCard: adminClubCardStore,
  adminClubs: adminClubsStore,
  adminCourses: adminCoursesStore,
  adminEventAwards: adminEventAwardsStore,
  adminEventEnrollments: adminEventEnrollmentsStore,
  adminEventFormatAwards: adminEventFormatAwardsStore,
  adminEventFormats: adminEventFormatsStore,
  adminEventResults: adminEventResultsStore,
  adminEventRounds: adminEventRoundsStore,
  adminEventTeams: adminEventTeamsStore,
  adminEvents: adminEventsStore,
  adminGroups: adminGroupsStore,
  adminHoleResults: adminHoleResultsStore,
  adminInvitations: adminInvitationsStore,
  adminMemberships: adminMembershipsStore,
  adminPlayerEnrollments: adminPlayerEnrollmentsStore,
  adminRoundAwards: adminRoundAwardsStore,
  adminRoundFormatAwards: adminRoundFormatAwardsStore,
  adminRoundFormats: adminRoundFormatsStore,
  adminRoundPayments: roundPaymentsStore,
  adminRoundResults: adminRoundResultsStore,
  adminSeasonAwards: adminSeasonAwardsStore,
  adminTeamGames: adminTeamGamesStore,
  adminTeamHoleResults: adminTeamHoleResultsStore,
  adminTeamResults: adminTeamResultsStore,
  auth: authStore,
  avatar: avatarStore,
  clubInvitations: clubInvitationsStore,
  clubs: clubsStore,
  errors: errorsStore,
  eventRegistration: eventRegistrationStore,
  eventRounds: eventRoundsStore,
  events: eventStore,
  games: gamesStore,
  header: headerStore,
  holeResults: holeResultsStore,
  invitation: invitationStore,
  loader: loaderStore,
  memberships: membershipsStore,
  notifications: notificationsStore,
  pages: pagesStore,
  playerEditorModal: playerEditorModalStore,
  profile: playerProfileStore,
  roundResults: roundResultsStore,
  roundScores: roundScoresStore,
  roundTees: roundTeesStore,
  scores: scoresStore,
  seasonAwards: seasonAwardsStore,
  seasons: seasonsStore,
  standings: standingsStore,
  teamHoleResults: adminTeamHoleResultsStore,
  user: userStore
};

const GlobalContext = React.createContext(store);

const { Provider, Consumer } = GlobalContext;

export { store, Provider, Consumer, GlobalContext };
